import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container",
    on: {
      click: _vm.toJump
    }
  }, [_c("canvas", {
    attrs: {
      id: "canvas"
    }
  }), _c("div", {
    staticStyle: {
      overflow: "auto",
      flex: "1"
    }
  }, [_vm.$route.query.from != "video" ? _c("div", {
    staticClass: "img-con"
  }, [Object.prototype.toString.call(_vm.detailData["content"]["indexes"]) == "[object Object]" && _vm.detailData["content"]["indexes"]["101"]["body"].length > 0 && _vm.detailData["content"]["indexes"]["101"]["body"][0].type == 1 ? _c("img", {
    attrs: {
      src: _vm.detailData["content"]["indexes"]["101"]["body"][0].thumbUrl,
      alt: ""
    }
  }) : _vm._e()]) : _vm._e(), _vm.$route.query.from == "video" ? _c("div", {
    staticClass: "video-con"
  }, [_c("video", {
    staticClass: "video",
    attrs: {
      controls: "",
      src: ""
    }
  })]) : _vm._e(), _vm.$route.query.from == "video" ? _c("div", {
    staticClass: "video-detail"
  }, [_c("div", {
    staticClass: "user"
  }, [_c("div", {
    staticClass: "user-info"
  }, [_vm.detailData.user.avatar ? _c("img", {
    attrs: {
      src: _vm.detailData.user.avatar,
      alt: ""
    }
  }) : _c("img", {
    attrs: {
      src: require("../../assets/images/icon_avatar.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "txt"
  }, [_c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.detailData.user.nickname))]), _c("span", {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.detailData.createdAt))])])])]), _c("div", {
    staticClass: "text"
  }, [_vm._v("In 2020, MG launched MG Pilot, which is another representative product of MG after HS. So is MG Pilot worth buying?")]), _vm._m(0)]) : _vm._e(), _vm.$route.query.from == "activity" ? _c("div", [!_vm.detailData.activity_registration ? _c("div", {
    staticClass: "sign-up"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Team.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Sign up")])]) : _vm._e(), _vm.detailData.activity_registration ? _c("div", {
    staticClass: "sign-up registered"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Team.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("registered")])]) : _vm._e(), _c("div", {
    staticClass: "activity-article"
  }, [_c("h4", [_vm._v(_vm._s(_vm.detailData.title))]), _c("div", {
    staticClass: "position-time"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm.detailData.start_at || _vm.detailData.end_at ? _c("div", {
    staticClass: "time"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Time.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.detailData.start_at) + " - " + _vm._s(_vm.detailData.end_at))])]) : _vm._e(), _vm.detailData.position.address ? _c("div", {
    staticClass: "position"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Location.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.detailData.position.address))])]) : _vm._e()]), _c("div", {
    staticClass: "right"
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detailData.activity_registration))]), _c("span", {
    staticClass: "text"
  }, [_vm._v("Sign up")])])]), _c("div", {
    staticClass: "activity-text",
    domProps: {
      innerHTML: _vm._s(_vm.detailData.content.text)
    }
  }), Object.prototype.toString.call(_vm.detailData["content"]["indexes"]) == "[object Object]" && _vm.detailData["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
    staticClass: "item-wrap"
  }, _vm._l(_vm.shiftArr, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: item.thumbUrl,
        alt: ""
      }
    })]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "link"
  }, [_vm.detailData.activity_link_title ? _c("span", [_vm._v(_vm._s(_vm.detailData.activity_link_title))]) : _vm._e(), _vm.detailData.activity_link ? _c("span", [_vm._v(_vm._s(_vm.detailData.activity_link))]) : _vm._e()]), _c("div", {
    staticClass: "line"
  })])]) : _vm._e(), _vm.$route.query.from == "club" || _vm.$route.query.from == "news" ? _c("div", [_c("div", {
    staticClass: "article"
  }, [_c("h4", [_vm._v(_vm._s(_vm.detailData.title))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$route.query.from == "club",
      expression: "$route.query.from == 'club'"
    }],
    staticClass: "user"
  }, [_c("div", {
    staticClass: "user-info"
  }, [_vm.detailData.user.avatar ? _c("img", {
    staticClass: "img",
    attrs: {
      src: _vm.detailData.user.avatar,
      alt: ""
    }
  }) : _c("img", {
    staticClass: "img",
    attrs: {
      src: require("../../assets/images/icon_avatar.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "txt"
  }, [_c("span", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.detailData.user.nickname))]), _c("span", {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.detailData.createdAt))])])]), _vm.storeUserId != _vm.detailData.user.userId ? _c("div", [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailData.user.follow_status == 2,
      expression: "detailData.user.follow_status == 2"
    }],
    staticClass: "follow"
  }, [_vm._v(_vm._s(_vm.$t("Follow")))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailData.user.follow_status == 1,
      expression: "detailData.user.follow_status == 1"
    }],
    staticClass: "unFollow"
  }, [_vm._v(_vm._s(_vm.$t("friend")))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailData.user.follow_status == 0,
      expression: "detailData.user.follow_status == 0"
    }],
    staticClass: "unFollow"
  }, [_vm._v(" " + _vm._s(_vm.$t("Unfollow")) + " ")])]) : _vm._e()]), _c("div", {
    staticClass: "content",
    domProps: {
      innerHTML: _vm._s(_vm.detailData.content.text)
    }
  }), Object.prototype.toString.call(_vm.detailData["content"]["indexes"]) == "[object Object]" && _vm.detailData["content"]["indexes"]["101"]["body"].length > 0 ? _c("div", {
    staticClass: "item-wrap"
  }, _vm._l(_vm.shiftArr, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item"
    }, [item.type == 1 ? _c("img", {
      attrs: {
        src: item.thumbUrl,
        alt: ""
      }
    }) : _vm._e(), item.type == 2 ? _c("video", {
      staticClass: "video",
      attrs: {
        controls: "",
        controlslist: "nodownload noremoteplayback",
        src: item.thumbUrl
      }
    }) : _vm._e()]);
  }), 0) : _vm._e()])]) : _vm._e(), _vm.$route.query.from == "club" ? _c("div", {
    staticClass: "tags"
  }, _vm._l(_vm.detailData.thread_topic, function (item1) {
    return _c("div", {
      key: item1.id,
      staticClass: "tags-item"
    }, [_c("img", {
      staticClass: "sign",
      attrs: {
        src: require("../../assets/images/Topic-list-icon-blue.png"),
        alt: ""
      }
    }), _c("span", {
      staticClass: "clubs"
    }, [_vm._v(_vm._s(item1.content))])]);
  }), 0) : _vm._e(), _vm.detailData.user.userId == _vm.storeUserId ? _c("div", {
    staticClass: "buttop-wrap"
  }, [_c("van-button", {
    attrs: {
      type: "danger",
      size: "mini"
    }
  }, [_vm._v("Delete this post")])], 1) : _vm._e(), _c("div", {
    staticClass: "comments"
  }, [_c("h4", [_vm._v(_vm._s(_vm.$t("AllComments")))]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.commentList.length == 0,
      expression: "commentList.length == 0"
    }],
    staticClass: "noComment"
  }, [_vm._v("No comment")]), _vm._l(_vm.commentList, function (item) {
    return _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.commentList.length > 0,
        expression: "commentList.length > 0"
      }, {
        name: "longpress",
        rawName: "v-longpress",
        value: _vm.longpress,
        expression: "longpress"
      }],
      key: item.id,
      class: ["commnets-item", {
        selected: item.isSelected
      }],
      on: {
        touchstart: function touchstart($event) {
          return _vm.start(item.userId, item.id, item);
        }
      }
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info"
    }, [item.user.avatar ? _c("img", {
      staticClass: "img",
      attrs: {
        src: item.user.avatar,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.user.nickname))]), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.createdAt))])])]), _c("div", {
      staticClass: "comments-goods"
    }, [!item.isLiked ? _c("img", {
      attrs: {
        src: require("../../assets/images/ic_other_more_like.png"),
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("../../assets/images/Like1.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.likeCount))])])]), _c("div", {
      staticClass: "comments-con"
    }, [_c("span", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.content))]), item.lastThreeComments.length > 0 ? _c("div", {
      staticClass: "reply-con"
    }, _vm._l(item.lastThreeComments, function (itm) {
      return _c("div", {
        key: itm.id,
        staticClass: "reply-item"
      }, [itm.commentUserId ? _c("div", [_c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(itm.user.nickname))]), _vm._v(" "), _c("span", [_vm._v("Reply")]), _vm._v(" "), _c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(itm.commentUser.nickname))]), _c("span", [_vm._v(" : ")]), _vm._v(_vm._s(itm.content) + " ")]) : _c("div", [_c("span", {
        staticClass: "name"
      }, [_vm._v(_vm._s(itm.user.nickname))]), _c("span", [_vm._v(" : ")]), _vm._v(_vm._s(itm.content))])]);
    }), 0) : _vm._e()])]);
  })], 2)]), _vm.detailData.is_comment === 1 || _vm.detailData.is_comment === null ? _c("div", {
    staticClass: "input-con"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    ref: "inputs",
    attrs: {
      type: "text",
      disabled: "",
      placeholder: _vm.$t(_vm.placeholder)
    },
    domProps: {
      value: _vm.inputValue
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.inputValue = $event.target.value;
      }, function ($event) {
        return _vm.input(_vm.inputValue);
      }],
      focus: _vm.focus,
      blur: _vm.blur,
      keyup: _vm.getKeyCode
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isFocus,
      expression: "!isFocus"
    }],
    staticClass: "item-con"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_comment.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.detailData.likeReward.postCount))])]), _c("div", {
    staticClass: "item"
  }, [!_vm.detailData.isLike ? _c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_like.png"),
      alt: ""
    }
  }) : _c("img", {
    attrs: {
      src: require("../../assets/images/Like1.png"),
      alt: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.detailData.likeReward.likePayCount))])]), _vm.detailData.isFavorite ? _c("div", {
    staticClass: "item"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Collection1.png"),
      alt: ""
    }
  }), _c("span")]) : _c("div", {
    staticClass: "item"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_other_more_collect.png"),
      alt: ""
    }
  }), _c("span")])]), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFocus,
      expression: "isFocus"
    }],
    class: ["send", {
      active: !_vm.isEmpty
    }]
  }, [_vm._v(_vm._s(_vm.$t("send")))])]) : _vm._e(), _vm.detailData.is_comment === 0 && _vm.$route.query.from == "activity" ? _c("div", [!_vm.detailData.activity_registration ? _c("div", {
    staticClass: "sign-up-btn"
  }, [_vm._v(" Sign up ")]) : _vm._e(), _vm.detailData.activity_registration ? _c("div", {
    staticClass: "sign-up-btn registered"
  }, [_vm._v(" Sign up ")]) : _vm._e()]) : _vm._e(), _c("div", {
    ref: "qrCodeUrl",
    staticClass: "qrcode"
  }), _c("div", {
    staticClass: "bottom-box"
  }), _c("van-popup", {
    style: {
      height: "200px",
      zIndex: 99999
    },
    attrs: {
      position: "bottom"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    staticClass: "pop"
  }, [_c("span", {
    on: {
      click: _vm.del
    }
  }, [_vm._v("删除")]), _c("span", {
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "like"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Like1.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "name"
  }, [_c("span", [_vm._v("Quella")]), _c("span", [_vm._v(" , ")]), _c("span", [_vm._v("William")]), _vm._v(" 5164 likes. ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };